import { type KeyboardEventKey, type ModifierKeys } from '@frameio/vapor';
import type { ActionModifiers } from '../types/CommandKeys';

/**
 * Returns true if the given key is a supported modifier key name, and narrows
 * the typescript type. Note that CommandRegistry supports only a subset of all
 * modifier key names in the KeyboardEvent spec.
 */
export function isModifierKey(key: KeyboardEventKey): key is ModifierKeys {
  return ['Alt', 'Control', 'Meta', 'Shift'].includes(key);
}

export function isActionModifier(
  action: ActionModifiers
): action is ActionModifiers {
  return ['Click', 'Drag', 'Hold'].includes(action);
}
